import type { paths } from 'apis/cloud-connect-subscription';
import createClient from 'openapi-fetch';

import { CONFIG } from 'src/config';

import { addAuthHeader } from './middleware/addAuthHeader';
import { throwOnErrorResponse } from './middleware/throwOnErrorResponse';

const cloudConnectSubscriptionApiClient = createClient<paths>({
  baseUrl: CONFIG.CloudConnectApiUrl,
});

cloudConnectSubscriptionApiClient.use(addAuthHeader, throwOnErrorResponse);

export { cloudConnectSubscriptionApiClient };
